import React from 'react';
import { Recipe } from '../../api/Recipe';
import { Heading, HtmlContent } from '../ui';

interface RecipeTextSectionsProps {
  recipe: Pick<Recipe, 'ingredients' | 'steps'>;
  ingredientsHeading?: string;
  stepsHeading?: string;
}

const RecipeTextSections: React.FC<RecipeTextSectionsProps> = ({
  recipe,
  ingredientsHeading = 'Ingrédients:',
  stepsHeading = 'Étapes:',
}) => {
  return (
    <>
      <Heading as="h4" marginTop={4}>{ingredientsHeading}</Heading>
      <HtmlContent html={recipe.ingredients} />
      <Heading as="h4" marginTop={4}>{stepsHeading}</Heading>
      <HtmlContent html={recipe.steps} />
    </>
  );
};

export default RecipeTextSections;
